enum WorkerStatus {
    Pending = 10,
    ReviewRequired = 80,
    Active = 90,
    Inactive = 91
}

export default WorkerStatus;